import { Navigate, Route, Routes } from 'react-router-dom';
import { AuthGuard } from './components/AuthGuard';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { CapturePage } from './pages/CapturePage';
import { ImageEditorPage } from './pages/ImageEditorPage';
import { ProcessingPage } from './pages/ProcessingPage';
import { ReviewPage } from './pages/ReviewPage';
import { CalendarPage } from './pages/CalendarPage';
import { SuccessPage } from './pages/SuccessPage';
import { AppointmentListPage } from './pages/AppointmentListPage';
import { AppointmentDetailPage } from './pages/AppointmentDetailPage';
import { SettingsPage } from './pages/SettingsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { MeetingHubPage } from './pages/MeetingHubPage';
import { MeetingTopicPage } from './pages/MeetingTopicPage';
import { CalendarOverviewPage } from './pages/CalendarOverviewPage';
import { CalendarImportPage } from './pages/CalendarImportPage';

const guarded = (element: React.ReactNode) => <AuthGuard>{element}</AuthGuard>;

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={guarded(<DashboardPage />)} />
      <Route path="/calendar" element={guarded(<CalendarOverviewPage />)} />
      <Route path="/calendar/import" element={guarded(<CalendarImportPage />)} />
      <Route path="/capture" element={guarded(<CapturePage />)} />
      <Route path="/capture/edit" element={guarded(<ImageEditorPage />)} />
      <Route path="/appointments/:id/processing" element={guarded(<ProcessingPage />)} />
      <Route path="/appointments/:id/review" element={guarded(<ReviewPage />)} />
      <Route path="/appointments/:id/calendar" element={guarded(<CalendarPage />)} />
      <Route path="/appointments/:id/success" element={guarded(<SuccessPage />)} />
      <Route path="/appointments" element={guarded(<AppointmentListPage />)} />
      <Route path="/appointments/:id" element={guarded(<AppointmentDetailPage />)} />
      <Route path="/meetings" element={guarded(<MeetingHubPage />)} />
      <Route path="/meeting-topics/:id" element={guarded(<MeetingTopicPage />)} />
      <Route path="/settings" element={guarded(<SettingsPage />)} />
      <Route path="/privacy" element={guarded(<PrivacyPage />)} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
